import React from "react";
import useReveal from "../hooks/useReveal";
import Hero from "../components/home/Hero";
import AboutSection from "../components/home/AboutSection";
import ServicesSection from "../components/home/ServicesSection";
import ExperienceSection from "../components/home/ExperienceSection";
import HairPreview from "../components/home/HairPreview";
import Testimonials from "../components/home/Testimonials";
import CtaBanner from "../components/home/CtaBanner";

export default function Home() {
  useReveal();
  return (
    <main>
      <Hero />
      <AboutSection />
      <ServicesSection />
      <ExperienceSection />
      <HairPreview />
      <Testimonials />
      <CtaBanner />
    </main>
  );
}
